import type { ReactNode } from "react";
import { formatProfitAmount, type ProfitAmount, profitStatusLabel } from "../profit-dashboard-view-model";

export function ProfitValue({ amount }: { amount: ProfitAmount }) {
  const color = amount.minor === null || amount.minor === 0n ? "text-text-primary" : amount.minor > 0n ? "text-emerald-500" : "text-red-500";
  return <div><span className={`font-mono ${color}`}>{formatProfitAmount(amount)}</span>{amount.reason && <p className="text-[11px] font-normal text-text-muted mt-1">{amount.reason}</p>}</div>;
}

export function ProfitCard({ title, children }: { title: string; children: ReactNode }) {
  return <section aria-label={title} className="bg-white rounded-lg border border-surface-border px-4 py-3"><h3 className="text-[11px] text-text-muted">{title}</h3><div className="text-sm font-semibold mt-1">{children}</div></section>;
}

export function ProfitStatus({ status }: { status: string }) {
  const color = status === "active" ? "text-emerald-600 bg-emerald-500/10" : status === "paused" ? "text-amber-600 bg-amber-500/10" : "text-text-secondary bg-surface";
  return <span className={`inline-flex px-2 py-0.5 rounded text-[11px] ${color}`}>{profitStatusLabel(status)}</span>;
}

export function ProfitReadError({ error, stale, retry }: { error: string; stale: boolean; retry: () => void }) {
  return <div role="alert" className="rounded-lg border border-red-500/20 bg-red-500/5 px-4 py-3 text-sm text-red-600">
    <p>{stale ? `刷新失败，当前为上次数据。${error}` : error}</p>
    <button type="button" onClick={retry} className="underline mt-2">重试</button>
  </div>;
}
